export const WHATSAPP_NUMBER = "5513997312739";
export const WHATSAPP_DISPLAY = "(13) 99731-2739";
export const CITY = "Bertioga/SP";
export const CENTRAL_URL = "https://hpnet.centralassinante.com.br/#/login";

export const waLink = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1586182987320-4f376d39d787?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const PLANS = [
  {
    tier: "BASIC",
    speed: "100",
    price: "79,90",
    popular: false,
    rec: "Ideal pra 1 ou 2 pessoas: redes sociais, vídeos em HD e e-mails no dia a dia.",
    message: "Olá! Quero assinar o plano BASIC de 100 MEGAS por R$ 79,90/mês.",
  },
  {
    tier: "ESSENTIAL",
    speed: "300",
    price: "99,90",
    popular: true,
    rec: "Recomendado pra família: streaming em várias telas, home office e videochamadas.",
    message:
      "Olá! Quero assinar o plano ESSENTIAL de 300 MEGAS por R$ 99,90/mês.",
  },
  {
    tier: "ULTRA",
    speed: "600",
    price: "119,90",
    popular: false,
    rec: "Ideal pra gamers e casas conectadas: 4K, jogos online sem lag e vários aparelhos ao mesmo tempo.",
    message:
      "Olá! Quero assinar o plano ULTRA de 600 MEGAS por R$ 119,90/mês.",
  },
];

export const PLAN_FEATURES = [
  "Fibra óptica até sua casa",
  "Suporte local em Bertioga",
  "Atendimento direto no WhatsApp",
];

export const FAQS = [
  {
    q: "Como faço pra assinar um plano?",
    a: "É só chamar a gente no WhatsApp: você escolhe o plano, a gente confirma a disponibilidade no seu endereço e agenda a instalação. Tudo resolvido pela conversa, sem burocracia.",
  },
  {
    q: "Quanto custa a instalação?",
    a: "O valor da instalação depende da sua região e das promoções vigentes. Fale com a gente no WhatsApp para conferir as condições de hoje.",
  },
  {
    q: "A velocidade contratada chega no Wi-Fi?",
    a: "A fibra chega na sua casa e o Wi-Fi distribui a conexão para os seus aparelhos. Para aproveitar toda a velocidade, vale usar aparelhos e roteadores compatíveis com o plano escolhido.",
  },
  {
    q: "Posso trocar de plano depois?",
    a: "Pode sim. Se a sua conexão precisar de mais velocidade, é só chamar no WhatsApp que a gente faz o upgrade do seu plano.",
  },
  {
    q: "Quais bairros a HPNET atende?",
    a: "Atendemos em Bertioga/SP. A disponibilidade pode variar por rua — manda seu endereço no WhatsApp que a gente confirma na hora.",
  },
];
